import { Alert } from 'src/design/atoms/Alert';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { Group } from 'src/design/atoms/Group';
import { Text } from 'src/design/atoms/Text';
import { useVersionCheck } from 'src/hooks/useVersionCheck';

/** @registry Fixed-position banner offering a reload when useVersionCheck detects a newer deployed app version. */
export function VersionUpdateBanner() {
  const { hasUpdate, reload } = useVersionCheck();

  if (!hasUpdate) return null;

  return (
    <Alert
      color="blue"
      variant="filled"
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 9999,
        maxWidth: 400,
        boxShadow: 'var(--mantine-shadow-lg)',
      }}
    >
      <Group justify="space-between" align="center" gap="md">
        <Text size="sm" fw={500} c="white">
          A new version is available! Please reload to continue.
        </Text>
        <BasicButton size="xs" variant="white" color="blue" onClick={reload}>
          Reload
        </BasicButton>
      </Group>
    </Alert>
  );
}
